import React from 'react';
import { Link } from 'react-router-dom';
import { LoaderNarrow } from '../../../components/loaders';
import _fetchApi from '../../../fetch';
import GlobalContext from '../../../global';
import { getTaskIcon } from '../Tasks';

const check = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="task-check"><path fillRule="evenodd" clipRule="evenodd" d="M3.70711 9.2929C3.31658 8.90238 2.68342 8.90238 2.29289 9.2929C1.90237 9.68343 1.90237 10.3166 2.29289 10.7071L7.29289 15.7071C7.69802 16.1122 8.36002 16.0948 8.74329 15.669L17.7433 5.66897C18.1128 5.25846 18.0795 4.62617 17.669 4.25671C17.2585 3.88726 16.6262 3.92053 16.2567 4.33104L7.96181 13.5476L3.70711 9.2929Z" fill="var(--submission-green)" /></svg>;

export class VisibleTaskList extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      tasks: [],
      count: undefined,
      loading: true,
      failed: false,
    };

    this.fetching = false;
    this.request_id = 0;
    this.used_props = null;
    this.filter_query = null;
    this.sentinel_ref = React.createRef();
    this.restore_task = props.restore_task;
  }

  constructSearch(props, add_offset) {
    let result = "";
    if (props.hasOwnProperty("search")) {
      result += "?query=" + props.search;
    } else {
      result += "?categories=" + props.categories_selected.map((element, index) => element ? index + 1 : "").filter(element => element).join(",");
      result += "&difficulties=" + props.difficulty_selected.map((element, index) => element ? index + 1 : "").filter(element => element).join(",");
      result += "&hidesolved=" + (props.hide_solved ? "1" : "0");
      result += "&order=" + props.sort_by;
      result += "&reversed=" + (props.reversed ? "1" : "0");
      if (add_offset) {
        result += "&offset=" + (this.state.tasks.length > 0 ? this.state.tasks[this.state.tasks.length - 1].id : "0");
      }
    }
    return result;
  }

  // props: a new filter (restart the list); no props: load the next page with the last filter
  getMoreTasks(props) {
    let was_scrolled = false;
    if (props) {
      if (this.used_props) this.restore_task = null; // the user changed the filter: nothing to restore
      this.setState({
        loading: true,
        failed: false,
        tasks: [],
        count: undefined,
      });
    } else {
      props = this.used_props;
      was_scrolled = true;
      this.setState({
        loading: true,
        failed: false,
      });
    }

    this.fetching = true;
    this.used_props = props;
    const request_id = ++this.request_id;
    const filter_query = this.constructSearch(props, was_scrolled);

    _fetchApi(`${props.hasOwnProperty("search") ? "/getTaskPreviewsByText" : "/getTaskPreviews"}${filter_query}`, this.context.token ? {
      method: "GET",
      headers: { "Authorization": "Bearer " + this.context.token, },
    } : { method: "GET", }).then(response => {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    }).then(result => {
      if (request_id !== this.request_id) return; // a newer filter has been requested meanwhile
      this.filter_query = filter_query;
      this.setState({
        tasks: was_scrolled ? this.state.tasks.concat(result.task_previews) : result.task_previews,
        loading: false,
        count: result.count,
      }, () => {
        this.fetching = false;
        this.restoreRow();
        this.recheckSentinel();
      });
    }).catch(() => {
      if (request_id !== this.request_id) return;
      this.fetching = false;
      this.setState({ loading: false, failed: true, });
    });
  }

  // back from a task: load pages until its row is there, then scroll it into view
  restoreRow() {
    if (!this.restore_task) return;
    const row = document.getElementById("task-" + this.restore_task);
    if (row || this.state.count <= this.state.tasks.length) {
      this.restore_task = null;
      row?.scrollIntoView({ block: "center", });
    } else {
      this.getMoreTasks();
    }
  }

  loadNextPage() {
    if (this.state.tasks.length > 0 && !this.fetching && !this.state.failed && this.state.count > this.state.tasks.length) {
      this.getMoreTasks();
    }
  }

  // IntersectionObserver only reports changes: re-observing makes it report the current state again,
  // so a page that still leaves the sentinel in view (tall screens) loads the next one
  recheckSentinel() {
    if (this.observer && this.sentinel_ref.current) {
      this.observer.unobserve(this.sentinel_ref.current);
      this.observer.observe(this.sentinel_ref.current);
    }
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(entries => {
      if (entries[entries.length - 1].isIntersecting) {
        this.loadNextPage();
      }
    }, { rootMargin: "0px 0px 600px 0px", });
    this.observer.observe(this.sentinel_ref.current);
  }

  componentWillUnmount() {
    this.observer.disconnect();
    this.request_id++;
  }

  render() {
    // Filter state handed to the task page (its sidebar lists the same search, and "back" restores it)
    const params = {};
    for (const [key, value] of new URLSearchParams(this.filter_query || "").entries()) {
      if (key !== "offset") params[key] = value;
    }

    return <div className="task-list-visible">
      <div className="tasklist-table">
        <div className="tasklist-header" aria-hidden="true">
          <span>ID</span>
          <span>Название</span>
          <span>Источник</span>
          <span>Решили</span>
          <span>Сложность</span>
        </div>
        {this.state.tasks.map((element, index) => {
          const dest = {
            pathname: `/tasks/${element.id}`,
            state: {
              category: "public",
              ...params,
              // the task page sidebar pages with the same cursor: start its list at this task
              ...(index > 0 && !params.hasOwnProperty("query") ? { offset: String(this.state.tasks[index - 1].id), } : {}),
            },
          };

          return <Link to={dest} className="tasklist-item" key={element.id} id={"task-" + element.id} onClick={() => this.props.onOpenTask(element.id)}>
            <span className="tasklist-cell tasklist-cell--id">{element.id}</span>
            <span className={"tasklist-cell tasklist-cell--name" + (element.solved ? " solved" : "")}>
              {element.solved && check}
              <span>{element.name}</span>
            </span>
            <span className="tasklist-meta">
              <span className="tasklist-cell tasklist-cell--source">{element.source}</span>
              <span className="tasklist-cell tasklist-cell--solved">{element.solved_by}</span>
            </span>
            <span className="tasklist-cell tasklist-cell--difficulty">{getTaskIcon(element.difficulty)}<span>{element.difficulty}%</span></span>
          </Link>;
        })}
      </div>
      <div ref={this.sentinel_ref} className="tasklist-sentinel" />
      {this.state.loading && <LoaderNarrow width="60" height="60" className="tasklist-loader" />}
      {this.state.failed && <p className="tasklist-end">
        Не удалось загрузить задачи. <button className="tasklist-retry" onClick={() => this.state.tasks.length > 0 ? this.getMoreTasks() : this.getMoreTasks(this.used_props)}>Повторить</button>
      </p>}
      {this.state.count === 0 && <p className="tasklist-end">Ничего не нашлось.</p>}
      {this.state.count === this.state.tasks.length && !this.state.loading && this.state.count > 100 && <p className="tasklist-end">Всему приходит конец. И списку задач тоже.</p>}
    </div>;
  }
}
